import { makeStyles, webLightTheme } from "@fluentui/react-components";

export const useMainPageStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
});

